import { Component, inject, OnInit } from '@angular/core';
import {
  IonButton,
  IonContent,
  ModalController,
} from '@ionic/angular/standalone';
import { GlobalPageHeaderComponent } from '../../../../../../../../components/global-page-header/global-page-header.component';
import { NlToBrPipe } from '../../../../../../../../pipes/nl-to-br.pipe';
import { TranslatePipe } from '@ngx-translate/core';
import { getTemperatureType } from '../../../../../../helper/temperature';

@Component({
  selector: 'app-p0003605-espinstallation-cl',
  templateUrl: './p0003605-espinstallation-cl.component.html',
  styleUrls: ['./p0003605-espinstallation-cl.component.scss'],
  imports: [
    GlobalPageHeaderComponent,
    IonButton,
    IonContent,
    NlToBrPipe,
    TranslatePipe,
  ],
})
export class P0003605ESPInstallationClComponent {
  private modalController: ModalController = inject(ModalController);

  constructor() {}

  async dismissModal() {
    await this.modalController.dismiss();
  }

  protected readonly getTemperatureType = getTemperatureType;
}
